import { ENV } from "../Utils";

export class ClientDB_API {
  baseApi = ENV.BASE_API;

  async createClient(accessToken, data) {
    try {
      // Actualiza el valor de 'miniature' con el URL de la imagen o el valor adecuado
      data.miniature = data.file; // Asumiendo que `data.file` tiene la imagen para la miniatura
      // Elimina el campo `file` de `data` ya que no lo necesitamos en el envío
      delete data.file;
      const formData = new FormData();
      // Añadir todos los datos restantes al FormData
      Object.keys(data).forEach((key) => formData.append(key, data[key]));
      const url = `${this.baseApi}/${ENV.API_ROUTES.CLIENTDB}`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async checkUserDBExists(id_Client) {
    const url = `${this.baseApi}/userdb/${id_Client}`;
    try {
      const response = await fetch(url);

      // Comprueba si la respuesta no es 200 y arroja un error con el mensaje del servidor
      if (!response.ok) {
        const result = await response.json();
        throw new Error(
          result.message || "Failed to fetch userDB existence status.",
        );
      }

      // Si la respuesta es exitosa, convierte a JSON y retorna solo el valor booleano
      const result = await response.json();
      return result.userDBExists; // Devuelve directamente el valor booleano true o false
    } catch (error) {
      console.error("Error al verificar la existencia de userDB:", error);
      throw error; // Re-lanza el error para que pueda manejarse en otro lugar si es necesario
    }
  }

  async createUserDB(accessToken, id_Client) {
    const url = `${this.baseApi}/clientdb/newcurse`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // Incluye el token de autorización
      },
      body: JSON.stringify({ id_Client }), // Enviamos el id_Client en el body como JSON
    };

    try {
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message || "Error al crear la UserDB.");
      }
      return result; // Devuelve un mensaje de éxito
    } catch (error) {
      console.error("Error al crear la UserDB:", error);
      throw error;
    }
  }

  async getClients(params) {
    try {
      const pageFilter = `page=${params?.page || 1}`;
      const limitFilter = `limit=${params?.limit || 10}`;
      const url = `${this.baseApi}/${ENV.API_ROUTES.CLIENTSDB}?${pageFilter}&${limitFilter}`;

      const response = await fetch(url);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateClient(accessToken, idClient, data) {
    try {
      if (data.miniature) {
        data.miniature = data.file;
      }
      // Elimina el campo `file` de `data` ya que no lo necesitamos en el envío
      delete data.file;
      const formData = new FormData();
      // Añadir todos los datos restantes al FormData
      Object.keys(data).forEach((key) => formData.append(key, data[key]));
      //console.log("data", data);  // Verifica que `file` no esté en `data` y que `miniature` tenga el valor correcto
      const url = `${this.baseApi}/${ENV.API_ROUTES.CLIENTDB}/${idClient}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteClient(accessToken, idClient) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.CLIENTDB}/${idClient}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }
}
